import React, { Component } from 'react'
import classes from './crew.module.css'
import { Spinner } from '../../Component/Spinner/Spinner'
import { Tabs } from '../../Component/UI/Tabs/Tabs'

export default class Crew extends Component {

    state = {
        items: 0,
        data: []
    }

    componentDidMount() {
        
        fetch('data.json')
        .then(res => res.json())
        .then(data => {
            console.log(data.crew)
            this.setState({data: data.crew[this.state.items]})
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.items !== prevState.items) {
            fetch('data.json')
            .then(res => res.json())
            .then(data => {
                
                this.setState({data: data.crew[this.state.items]})
            }) 
        }
    }


    changeTabHandler = index => {
        console.log(index)
        console.log(this.state.items)
        this.setState({items: index})
    }

    activeTabsHandler = index => {
        if (this.state.items === index) {
            return {
                backgroundColor: "#fff"
            }
        }
    }



    render() {
        console.log(this.state.data)
        let destinationData = <Spinner />
        

        if (this.state.data.length !== 0) {

           destinationData = (
            
            <div className=" pt-32 pb-10 px-9 lg:h-screen xl:h-full" >
            <section>
                
            </section>
                <h4 className="text-white text-xl tracking-widest lg:text-left lg:text-4xl lg:pl-32 lg:mt-20 font-barlow"><span className=" text-blue-700 font-bold mr-4">02</span>MEET YOUR CREW</h4>

                <section className="lg:grid grid-cols-2">
                <section className="lg:col-start-2">
                <img src={this.state.data.images.png} alt="planet" className="mt-12 m-auto lg:w-4/6"/>
                </section>

                <section className="lg:col-start-1 lg:row-start-1 lg:pl-32">
                <section className="lg:absolute lg:top-550 xl:top-3/4">
                    <Tabs>
                        <div className="w-full flex justify-center">
                            <button style={this.activeTabsHandler(0)} className="w-3 h-3 rounded-full mr-6 bg-gray-500" onClick={() => this.changeTabHandler(0)}/>
                            <button style={this.activeTabsHandler(1)} className="w-3 h-3 rounded-full mr-6 bg-gray-500" onClick={() => this.changeTabHandler(1)}/>
                            <button style={this.activeTabsHandler(2)} className="w-3 h-3 rounded-full mr-6 bg-gray-500" onClick={() => this.changeTabHandler(2)}/>
                            <button style={this.activeTabsHandler(3)} className="w-3 h-3 rounded-full mr-6 bg-gray-500" onClick={() => this.changeTabHandler(3)}/>
                        </div>
                    </Tabs>
                    
                </section>

                <div className="mt-10">
                    <h1 className="text-softGray font-Bellefair text-m lg:text-lg xl:text-3xl lg:text-left">{this.state.data.role.toUpperCase()}</h1>
                    <h1 className="font-Bellefair text-white text-2xl lg:text-2xl xl:text-7xl lg:text-left lg:mt-6">{this.state.data.name.toUpperCase()}</h1>
                    <p className="text-softGray mt-5 font-barlow lg:text-lg xl:text-3xl lg:text-left lg:leading-relaxed">{this.state.data.bio}</p>
                </div>
                </section>
                </section>
            </div>
           )
        }
        return (
            
            <div className={classes.container}>
                {destinationData}
            </div>
           
        )
    }
}

